import { Directive, HostListener } from '@angular/core';

import { NavigationService } from '../services/navigation/navigation-service.service';

@Directive({
    selector: '[appBacktoprevious]',
    standalone: false,
})
export class BacktopreviousDirective {
    constructor(private navigation: NavigationService) {}

    @HostListener('click')
    onClick(): void {
        this.navigation.goBack();
    }
}
